import axiosInstance from "./axiosInstance";
import { getPublicKeys } from "api/apiService";
import { setAppKeys } from "utils/appKeys";


export const login = async (credentials) => {
  const response = await axiosInstance.post("/connect", credentials);
  const { message, token, status, role, vendor_id } = response.data;

  if (!status) {
    throw new Error("Ugyldig legitimasjon. Prøv på nytt.");
  }

  const allowed = new Set(["admin", "vendor", "customer"]);
  if (!allowed.has(role)) {
    const shownRole = role || "unknown";
    throw new Error(`Rollen din (${shownRole}) har ikke tillatelse til å få tilgang.`);
  }

  // The signed JWT is the ONLY credential we accept. Previously we fell back to
  // storing the base64 `message` blob as the token when `token` was missing —
  // that blob is unsigned and forgeable, so a missing token must fail the login
  // instead of producing a bogus session (Dag 7).
  if (!token) {
    throw new Error("Innlogging feilet: server returnerte ikke et gyldig token.");
  }

  // `message` is a display-only base64 blob (id:email:fullName), not a credential.
  let user = { id: null, fullName: "", email: "" };
  try {
    const [idStr, email, fullName] = atob(message || "").split(":");
    user = { id: idStr, fullName, email };
  } catch (e) {
    // malformed/absent display payload — keep the empty defaults
  }

  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("token", token);
  localStorage.setItem("vendor_id", vendor_id);
  localStorage.setItem("loggedIn", "true");
  localStorage.setItem("inputEnabled", "true");
  localStorage.setItem("role", role);

    try {
      const res = await getPublicKeys();
      if (res?.ok && res?.data) {
        setAppKeys(res.data);
      }
    } catch (e) {
      console.warn("get_public_keys failed", e);
    }


  // Store the token securely

  return response.data;
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("inputEnabled");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("vendor_id");
  localStorage.removeItem("user");
  localStorage.removeItem("app_keys");
  // const response = await axiosInstance.post('/auth/logout');
  // return response.data;
};

// Add more auth-related API calls here
